export default __webpack_public_path__ + "static/media/dior.7cb96148.webp";